export default __webpack_public_path__ + "static/media/report_light_mode.3318971e.svg";